import axios from 'axios';

let url = '';

export const initTppService = (config: Record<string, any>) => {
    url = config.tppUrl;
};

export const validateRuleExpression = (data: AdvancedRuleExpressionValidationInput) => {
    return axios.post(`${url}/expression`, {
        ...data
    });
};
export const validateParameterExpression = (data: ParameterExpressionValidationInput) => {
    return axios.post(`${url}/attribute`, {
        ...data
    });
};

export const getIntellisenseData = async () => {
    const res = await axios.get<IntellisenseSchema>(`${url}/intellisense`);
    return res.data;
};
